import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'; // ES6
import { Button } from 'antd';

import { obtenirAvisos } from '../../actions/avis';
import { convertirTextAMomentUTC } from '../../commons/gestioDates';
import { textQuanNoHiHaDada } from '../../constants';
import errorBoundaryWrapper from '../commons/errorBoundaryWrapper';

const INTERVAL_PETICIO_AVISOS_EN_MINUTS = 5;
const INTERVAL_PETICIO_AVISOS_EN_MS = INTERVAL_PETICIO_AVISOS_EN_MINUTS * 1000 * 60;

class AvisMonitoritzacio extends Component {

    constructor(props) {
        super(props);
        this.state = {dataUltimaActualitzacio: null};
        this.actualitzarAvisos = this.actualitzarAvisos.bind(this);
    }

    componentDidMount() {
        this.actualitzarAvisos();
        this.objecteIntervalPeticioPeriodicaAlServidor = setInterval(() => this.actualitzarAvisos(), INTERVAL_PETICIO_AVISOS_EN_MS);
    }

    actualitzarAvisos() {
        if (!this.props.peticioObtenirAvisosEnCurs) {
            this.props.obtenirAvisos().then((dataPeticioText) => {
                const dataPeticio = convertirTextAMomentUTC(dataPeticioText);
                const dataUltimaActualitzacio = dataPeticio.local().format('DD-MM-YYYY HH:mm');
                this.setState({dataUltimaActualitzacio});
            });
        }
    }

    componentWillUnmount() {
        clearInterval(this.objecteIntervalPeticioPeriodicaAlServidor);
    }

    render() {
        const { peticioObtenirAvisosEnCurs } = this.props;
        const { dataUltimaActualitzacio } = this.state;

        return <div className='detall-monitoritzacio'>
            <strong>Monitoratge últimes 24h.</strong> 
            <span>Última actualització: {dataUltimaActualitzacio || textQuanNoHiHaDada}</span>
            <Button
                loading={peticioObtenirAvisosEnCurs}
                icon='sync'
                size='small'
                shape='circle'
                onClick={this.actualitzarAvisos} />
        </div>;
    }
}

AvisMonitoritzacio.propTypes = {
    peticioObtenirAvisosEnCurs: PropTypes.bool,
    obtenirAvisos: PropTypes.func
};

const mapStateToProps = (state) => ({
    peticioObtenirAvisosEnCurs: state.avis.visualitzacio.avisos.peticioObtenirEnCurs
});

export default errorBoundaryWrapper(connect(mapStateToProps, { obtenirAvisos })(AvisMonitoritzacio));



// WEBPACK FOOTER //
// ./src/components/avis/avisMonitoritzacio.js